@if (shouldShowGenericError) {
  <div class="d-flex align-items-center bg-auth border-top border-top-2 border-primary"
    style="height: 100%;min-height:100%;">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 col-md-6 col-xl-5 order-md-2 mb-5 mb-md-0">
          <!-- Image -->
          <div class="text-center">
            <img alt="..." class="img-fluid"
              src="/assets/images/no-result.svg">
            </div>
          </div>
          <div class="col-12 col-md-6 col-xl-7 order-md-1 my-5">
            <div class="text-center">
              <!-- Preheading -->
              <h6 class="text-uppercase text-muted mb-4">
                Erreur inconnue
              </h6>
              <!-- Heading -->
              <h1 class="display-4 mb-5">
                Erreur de connexion
              </h1>
              <div class="alert alert-danger text-start">
                Désolé, nous avons rencontré une erreur inconnue. Veuillez réessayer de nouveau. Si cette erreur
                survient à nouveau, veuillez nous contacter en utilisant l'icône de clavardage en bas à droite.
              </div>
              <div class="alert alert-light text-start">
                <p><strong>{{ unknownError?.['title'] ?? "Erreur iconnue." }}</strong></p>
                <h5>Informations supplémentaires sur l'erreur:</h5>
                <pre>{{ JSON.stringify(unknownError) ?? "Erreur inconnue." }}</pre>
              </div>
              <!-- Button -->
              <a class="btn btn-lg btn-primary" routerLink="/logout">
                Se reconnecter à nouveau
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  }


  <router-outlet></router-outlet>
